import { JSEncrypt } from 'jsencrypt'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey =
  'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJcQ6RHq1LSUc7OUEDiSkTU6Onpasfl0\n' +
  'WUPk8V8A4ZlPRVP5uuRUMZIW8AiWHtN9mZJ46O0I8YLMx2pOKlP/uasCAwEAAQ=='

const privateKey =
  'MIIBVAIBADANBgkqhkiG9w0BAQEFAASCAT4wggE6AgEAAkEAlxDpEerUtJRzs5QQ\n' +
  'OJKRNTo6elqx+XRZQ+TxXwDhmU9FU/m65FQxkhbwCJYe032Zknjo7QjxgszHak4q\n' +
  'U/+5qwIDAQABAkEAgvh7SThyT1lBcpjU82dHE4G3P2swUBjqZ22vQnGuJc56SlwK\n' +
  'joBonPaahjPmPRleUGw4yt5+q9bbTOYDc+DiWQIhAMWQqP3W+QMG6IUCMMOUpKKd\n' +
  'gi7RfxHMwcM5kykZL/itAiEAw79pfyzawpEdN965B/8p3mOfLvecMgjkl7BsyYF5\n' +
  'jrcCIFt9IxTx0Ty6nUDDA+v+UMNRZ3Dg6RRIGs6aQfC9Tj69AiBEbybyzzuryg/s\n' +
  '+HC32v1IQovkX6y70WAZqBRgXmOhAQIgR5ZOFGSIwcy0OtA3a/ifdnkiv8hWMcoa\n' +
  'CzY63mULIl0='

// 加密
export const encrypt = (txt: string) => {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

// 解密
export const decrypt = (txt: string) => {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey) // 设置私钥
  return encryptor.decrypt(txt) // 对数据进行解密
}
